import {
  listOfvhqybd2zx248 as listOf,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  Unit_instanceat14thlj150z as Unit_instance,
  plus310ted5e4i90h as plus,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  enumEntries20mr21zbe3az4 as enumEntries,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Enum3alwj03lh1n41 as Enum,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  listOf1jh22dvmctj1r as listOf_0,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  removeFirst1io7eo7dqtj5o as removeFirst,
  println2shhhgwwt4c61 as println,
  until1jbpn0z3f8lbg as until,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  random234odtwlu7lq2 as random,
  getOrNull1go7ef9ldk0df as getOrNull,
  Long2qws0ah9gnpki as Long,
  VOID7hggqo3abtya as VOID,
  toMutableList20rdgwi7d3cwi as toMutableList,
  random3bgrvtipfs9sh as random_0,
  abs1kdzbjes1idip as abs,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  toDuration28gf6ughsr3vf as toDuration_0,
  getKClass1s3j9wy1cofik as getKClass,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  first58ocm7j58k3q as first,
  drop3na99dw9feawf as drop,
  Duration5ynfiptaqcrg as Duration,
  numberToDouble210hrknaofnhf as numberToDouble,
  toLongw1zpgk99d84b as toLong,
  numberRangeToLong1p1p8t7uo97xl as numberRangeToLong,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  coerceAtLeast3jlgfquiyquc9 as coerceAtLeast,
  Duration__div_impl_dknbf41b3wgg5p924df as Duration__div_impl_dknbf4,
  _Duration___get_inWholeSeconds__impl__hpy7b32mb043ng683qx as _Duration___get_inWholeSeconds__impl__hpy7b3,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toString28s61jeiy4rb0 as toString_0,
  take9j4462mea726 as take,
  padStart36w1507hs626a as padStart,
  lazy2hsh8ze7j6ikd as lazy,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz629330ogi7dvp as Duration__hashCode_impl_u4exz6,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  toString30pk9tzaqopn as toString_1,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  coerceAtMostfyc3emgaderp as coerceAtMost,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
} from './kotlin-kotlin-stdlib.mjs';
import {
  SpriteAnimationagta0d6ji85w as SpriteAnimation,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views116j359zi8nvf as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  addTo25e29vq105prw as addTo,
  Companion_instance1qzytx5vkv693 as Companion_instance,
  Text3kimhvgfxflj3 as Text,
  xy1gb51vhy014mx as xy,
  SolidRect131p7hyzlx7j8 as SolidRect,
  addUpdater1la23qj9g2d42 as addUpdater,
  get_mouse1jstwhfaumelj as get_mouse,
  setText209z1w9h7o9hy as setText,
  centerOnStage1tf2oda60yrak as centerOnStage,
  MouseEvents19mapgq8ez76g as MouseEvents,
  Scenezu810y12qpqp as Scene,
  Korge3fi4cwjkh8up9 as Korge,
  UIVerticalStack2gichhwk4pg3x as UIVerticalStack,
  UIVerticalFillcra9r5nmzb6d as UIVerticalFill,
  Companion_getInstancequ1o8fwft10r as Companion_getInstance_0,
  UIButton259u54yn72ttw as UIButton,
  centerXOn3acn3bw226nj3 as centerXOn,
  UITextInput3hf6kt3o0p9up as UITextInput,
  alignLeftToRightOf25wtg1v682ku8 as alignLeftToRightOf,
  alignTopToTopOf1pzlngle4qef6 as alignTopToTopOf,
  Stage1ggtrzujnnkl0 as Stage,
  Sprite19oods84ct31j as Sprite,
  positionu6441b7hkb4l as position,
  get_centeredilxldnbf7ma6 as get_centered,
  size3ul8wgwwt88hf as size,
  rotation29g98bv3f78wn as rotation,
  ColorTransformFilter1faqlnyd4nsx3 as ColorTransformFilter,
  addFilter3artfhx3aolvq as addFilter,
} from './korge-root-korge.mjs';
import {
  Vector2I2k5512l4eeahb as Vector2I,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_1,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_2,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_3,
  Vector2F2yb91r49vy4m7 as Vector2F,
  Angle__toString_impl_786qkyjyicm41uc2nj as Angle__toString_impl_786qky,
  Angle__hashCode_impl_szcndtx0rhatnvuhb1 as Angle__hashCode_impl_szcndt,
  times2qwyhtxg42qph as times,
  Angle__times_impl_v3s9y220yjbrxc13c3b as Angle__times_impl_v3s9y2,
  Angle__plus_impl_26v37karx983dsduoy as Angle__plus_impl_26v37k,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_4,
  Angle2itorpob18n08 as Angle,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_6,
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get1va4pgy24ix4t as get,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_7,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  readAtlas3i3fpdxd2wy0v as readAtlas,
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  PNG_getInstance30449hvvlhbbs as PNG_getInstance,
  RGBA__interpolateWith_impl_mw7p5y1g8prnof19q7i as RGBA__interpolateWith_impl_mw7p5y,
  Companion_instancepqnabj9nutrw as Companion_instance_0,
  ColorAdd_pack3r2zgiosu4kvu as ColorAdd_pack,
  _ColorAdd___init__impl__q78um52f1128lcwf1fa as _ColorAdd___init__impl__q78um5,
  _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3 as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8 as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  _ColorAdd___get_r__impl__j9xkne1kbrts3qrn6g1 as _ColorAdd___get_r__impl__j9xkne,
  _ColorAdd___get_g__impl__itrhk12096raxfex02b as _ColorAdd___get_g__impl__itrhk1,
  _ColorAdd___get_b__impl__grv87a2vw0avtnx85s8 as _ColorAdd___get_b__impl__grv87a,
  _ColorAdd___get_a__impl__c1r8ux255rv89tur9tr as _ColorAdd___get_a__impl__c1r8ux,
  ColorTransform3dmo0aeuiflxt as ColorTransform,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_fast37cu8s8qwnuyi as get_fast,
  get_secondsjblpw5qd4dzj as get_seconds,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  _FastDuration___get_milliseconds__impl__ffr17unfwkaxi4cy42 as _FastDuration___get_milliseconds__impl__ffr17u,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  launchImmediatelylnv8lnistpdy as launchImmediately,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_8,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Assets {
  constructor(atlas) {
    this.jdh_1 = atlas;
    this.kdh_1 = this.jdh_1.bi('blocked');
    this.ldh_1 = this.jdh_1.bi('transparent');
    this.mdh_1 = this.jdh_1.bi('empty');
    this.ndh_1 = this.jdh_1.bi('corner');
    this.odh_1 = this.jdh_1.bi('start');
    this.pdh_1 = this.jdh_1.bi('cross');
    this.qdh_1 = this.jdh_1.bi('straightH');
    this.rdh_1 = this.jdh_1.bi('straightV');
    var tmp = this;
    var tmp_0 = listOf(this.ldh_1);
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(1, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'Assets.startFluid.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.jdh_1.bi('start-fluid' + it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    tmp.sdh_1 = new SpriteAnimation(plus(tmp_0, destination));
    var tmp_1 = this;
    var tmp_2 = listOf(this.ldh_1);
    // Inline function 'kotlin.collections.map' call
    var this_1 = numberRangeToNumber(1, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var inductionVariable_0 = this_1.d2_1;
    var last_0 = this_1.e2_1;
    if (inductionVariable_0 <= last_0)
      do {
        var item_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'Assets.cornerFluid.<anonymous>' call
        var it_0 = item_0;
        var tmp$ret$3 = this.jdh_1.bi('corner-fluid' + it_0);
        destination_0.h(tmp$ret$3);
      }
       while (!(item_0 === last_0));
    tmp_1.tdh_1 = new SpriteAnimation(plus(tmp_2, destination_0));
    var tmp_3 = this;
    var tmp_4 = listOf(this.ldh_1);
    // Inline function 'kotlin.collections.map' call
    var this_2 = numberRangeToNumber(1, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var inductionVariable_1 = this_2.d2_1;
    var last_1 = this_2.e2_1;
    if (inductionVariable_1 <= last_1)
      do {
        var item_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'Assets.cornerFluidFlipped.<anonymous>' call
        var it_1 = item_1;
        var tmp$ret$6 = this.jdh_1.bi('corner-fluid-flip' + it_1);
        destination_1.h(tmp$ret$6);
      }
       while (!(item_1 === last_1));
    tmp_3.udh_1 = new SpriteAnimation(plus(tmp_4, destination_1));
    var tmp_5 = this;
    var tmp_6 = listOf(this.ldh_1);
    // Inline function 'kotlin.collections.map' call
    var this_3 = numberRangeToNumber(1, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var inductionVariable_2 = this_3.d2_1;
    var last_2 = this_3.e2_1;
    if (inductionVariable_2 <= last_2)
      do {
        var item_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'Assets.straightFluid.<anonymous>' call
        var it_2 = item_2;
        var tmp$ret$9 = this.jdh_1.bi('straight-fluid' + it_2);
        destination_2.h(tmp$ret$9);
      }
       while (!(item_2 === last_2));
    tmp_5.vdh_1 = new SpriteAnimation(plus(tmp_6, destination_2));
    var tmp_7 = this;
    var tmp_8 = listOf(this.ldh_1);
    // Inline function 'kotlin.collections.map' call
    var this_4 = numberRangeToNumber(1, 5);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList.w(collectionSizeOrDefault(this_4, 10));
    var inductionVariable_3 = this_4.d2_1;
    var last_3 = this_4.e2_1;
    if (inductionVariable_3 <= last_3)
      do {
        var item_3 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        // Inline function 'Assets.nextAnimation.<anonymous>' call
        var it_3 = item_3;
        var tmp$ret$12 = this.jdh_1.bi('next-animation' + it_3);
        destination_3.h(tmp$ret$12);
      }
       while (!(item_3 === last_3));
    tmp_7.wdh_1 = new SpriteAnimation(plus(tmp_8, destination_3));
  }
  toString() {
    return 'Assets(atlas=' + toString(this.jdh_1) + ')';
  }
  hashCode() {
    return hashCode(this.jdh_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Assets))
      return false;
    var tmp0_other_with_cast = other instanceof Assets ? other : THROW_CCE();
    if (!equals(this.jdh_1, tmp0_other_with_cast.jdh_1))
      return false;
    return true;
  }
}
class Direction extends Enum {
  constructor(name, ordinal, vec, char) {
    super(name, ordinal);
    this.zdh_1 = vec;
    this.adi_1 = char;
  }
  bdi() {
    var tmp;
    switch (this.r3_1) {
      case 0:
        tmp = Direction_DOWN_getInstance();
        break;
      case 1:
        tmp = Direction_UP_getInstance();
        break;
      case 2:
        tmp = Direction_RIGHT_getInstance();
        break;
      case 3:
        tmp = Direction_LEFT_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  cdi() {
    var tmp;
    switch (this.r3_1) {
      case 0:
        tmp = Direction_RIGHT_getInstance();
        break;
      case 3:
        tmp = Direction_DOWN_getInstance();
        break;
      case 1:
        tmp = Direction_LEFT_getInstance();
        break;
      case 2:
        tmp = Direction_UP_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  ddi() {
    var tmp;
    switch (this.r3_1) {
      case 0:
        tmp = Companion_getInstance_1().d25_1;
        break;
      case 3:
        tmp = Companion_getInstance_1().e25_1;
        break;
      case 1:
        tmp = Companion_getInstance_1().f25_1;
        break;
      case 2:
        tmp = Companion_getInstance_1().g25_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
class Companion {}
class Orientation extends Enum {
  constructor(name, ordinal, directions) {
    super(name, ordinal);
    this.gdi_1 = directions;
  }
}
class GameOver {
  constructor(score) {
    this.hdi_1 = score;
  }
  toString() {
    return 'GameOver(score=' + this.hdi_1.toString() + ')';
  }
  hashCode() {
    return this.hdi_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameOver))
      return false;
    var tmp0_other_with_cast = other instanceof GameOver ? other : THROW_CCE();
    if (!this.hdi_1.equals(tmp0_other_with_cast.hdi_1))
      return false;
    return true;
  }
}
class NextLevel {
  constructor(score) {
    this.idi_1 = score;
  }
  toString() {
    return 'NextLevel(score=' + this.idi_1.toString() + ')';
  }
  hashCode() {
    return this.idi_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NextLevel))
      return false;
    var tmp0_other_with_cast = other instanceof NextLevel ? other : THROW_CCE();
    if (!this.idi_1.equals(tmp0_other_with_cast.idi_1))
      return false;
    return true;
  }
}
class Scored {
  constructor(x, y, score) {
    this.jdi_1 = x;
    this.kdi_1 = y;
    this.ldi_1 = score;
  }
  toString() {
    return 'Scored(x=' + this.jdi_1 + ', y=' + this.kdi_1 + ', score=' + this.ldi_1.toString() + ')';
  }
  hashCode() {
    var result = this.jdi_1;
    result = imul(result, 31) + this.kdi_1 | 0;
    result = imul(result, 31) + this.ldi_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scored))
      return false;
    var tmp0_other_with_cast = other instanceof Scored ? other : THROW_CCE();
    if (!(this.jdi_1 === tmp0_other_with_cast.jdi_1))
      return false;
    if (!(this.kdi_1 === tmp0_other_with_cast.kdi_1))
      return false;
    if (!this.ldi_1.equals(tmp0_other_with_cast.ldi_1))
      return false;
    return true;
  }
}
class Placed {}
class StagingArea {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.mdi_1 = ArrayList.h1();
    this.ndi_1 = 5;
    var tmp_0 = this;
    var tmp_1 = StagingArea$generators$lambda;
    var tmp_2 = StagingArea$generators$lambda_0;
    var tmp_3 = StagingArea$generators$lambda_1;
    var tmp_4 = StagingArea$generators$lambda_2;
    var tmp_5 = StagingArea$generators$lambda_3;
    var tmp_6 = StagingArea$generators$lambda_4;
    tmp_0.odi_1 = listOf_0([tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, StagingArea$generators$lambda_5]);
  }
  pdi() {
    var ret = removeFirst(this.mdi_1);
    println(toString(this.mdi_1) + ' ' + toString(ret));
    this.qdi();
    println(toString(this.mdi_1));
    return ret;
  }
  qdi() {
    // Inline function 'kotlin.collections.forEach' call
    var progression = until(this.mdi_1.e1(), this.ndi_1);
    var inductionVariable = progression.d2_1;
    var last = progression.e2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'StagingArea.replenish.<anonymous>' call
        // Inline function 'kotlin.collections.random' call
        var this_0 = this.odi_1;
        var tmp$ret$0 = random(this_0, Default_getInstance());
        this.mdi_1.h(tmp$ret$0());
      }
       while (!(element === last));
  }
}
class PlayField {
  constructor(xtiles, ytiles, stagingArea, currentLevel, score, eventCallback) {
    score = score === VOID ? new Long(0, 0) : score;
    this.rdi_1 = xtiles;
    this.sdi_1 = ytiles;
    this.tdi_1 = stagingArea;
    this.udi_1 = currentLevel;
    this.vdi_1 = score;
    this.wdi_1 = eventCallback;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(1, this.rdi_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'PlayField.tiles.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        var this_1 = numberRangeToNumber(1, this.sdi_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
        var inductionVariable_0 = this_1.d2_1;
        var last_0 = this_1.e2_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'PlayField.tiles.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new EmptyTile();
            destination_0.h(tmp$ret$0);
          }
           while (!(item_0 === last_0));
        var tmp$ret$3 = toMutableList(destination_0);
        destination.h(tmp$ret$3);
      }
       while (!(item === last));
    tmp.xdi_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.ranges.random' call
    var this_2 = until(2, this.rdi_1 - 2 | 0);
    tmp_0.ydi_1 = random_0(this_2, Default_getInstance());
    var tmp_1 = this;
    // Inline function 'kotlin.ranges.random' call
    var this_3 = until(2, this.sdi_1 - 2 | 0);
    tmp_1.zdi_1 = random_0(this_3, Default_getInstance());
    this.adj_1 = this.udi_1.cdj_1;
    var tmp_2 = this.xdi_1.d1(this.ydi_1);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp_3 = toDuration(2, DurationUnit_SECONDS_getInstance());
    // Inline function 'kotlin.collections.random' call
    var this_4 = get_entries();
    var tmp$ret$9 = random(this_4, Default_getInstance());
    tmp_2.o3(this.zdi_1, new StartPipe(tmp_3, tmp$ret$9));
    // Inline function 'kotlin.repeat' call
    var times = this.udi_1.edj_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < times)
      do {
        var index = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'PlayField.<anonymous>' call
        var blockedX = 0;
        var blockedY = 0;
        $l$1: do {
          $l$0: do {
            // Inline function 'kotlin.ranges.random' call
            var this_5 = until(1, this.rdi_1 - 1 | 0);
            blockedX = random_0(this_5, Default_getInstance());
            // Inline function 'kotlin.ranges.random' call
            var this_6 = until(1, this.sdi_1 - 1 | 0);
            blockedY = random_0(this_6, Default_getInstance());
          }
           while (false);
          var tmp_4;
          if (abs(blockedY - this.zdi_1 | 0) < 2 && abs(blockedX - this.ydi_1 | 0) < 2) {
            tmp_4 = true;
          } else {
            var tmp_5 = this.xdi_1.d1(blockedX).d1(blockedY);
            tmp_4 = !(tmp_5 instanceof EmptyTile);
          }
        }
         while (tmp_4);
        this.xdi_1.d1(blockedX).o3(blockedY, new BlockedTile());
      }
       while (inductionVariable_1 < times);
  }
  gdj() {
    var tmp = this.xdi_1.d1(this.ydi_1).d1(this.zdi_1);
    (tmp instanceof StartPipe ? tmp : THROW_CCE()).gdj();
  }
  mdj(dt) {
    var result = null;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = this.xdi_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'PlayField.onUpdate.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var x = checkIndexOverflow(tmp1);
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index_0 = 0;
      var tmp0_iterator_0 = item.a1();
      while (tmp0_iterator_0.b1()) {
        var item_0 = tmp0_iterator_0.c1();
        // Inline function 'PlayField.onUpdate.<anonymous>.<anonymous>' call
        var tmp1_0 = index_0;
        index_0 = tmp1_0 + 1 | 0;
        var y = checkIndexOverflow(tmp1_0);
        var event = item_0.mdj(dt);
        if (event instanceof Overflow) {
          this.vdi_1 = this.vdi_1.y3(event.pdj_1);
          this.adj_1 = this.adj_1 - 1 | 0;
          this.wdi_1(new Scored(x, y, event.pdj_1));
          var pos = event.odj_1.zdh_1.v2i(Vector2I.t2f(x, y));
          var newTile = getTileOrNull(this, pos);
          if (newTile == null) {
            result = overOrNextLevel(this);
          } else {
            if (!newTile.qdj(event.odj_1, event.ndj_1)) {
              result = overOrNextLevel(this);
            }
          }
        } else {
          if (event != null) {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var tmp0_safe_receiver = result;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'PlayField.onUpdate.<anonymous>' call
      this.wdi_1(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver;
    }
    return tmp;
  }
  rdj(x, y) {
    var currentTile = this.xdi_1.d1(x).d1(y);
    if (currentTile.sdj()) {
      var tile = this.tdi_1.pdi();
      this.xdi_1.d1(x).o3(y, tile);
      this.wdi_1(new Placed(x, y, tile));
    }
  }
}
class GameSceneState {
  constructor(score, currentLevel, remainingLevels) {
    this.idk_1 = score;
    this.jdk_1 = currentLevel;
    this.kdk_1 = remainingLevels;
  }
  toString() {
    return 'GameSceneState(score=' + this.idk_1.toString() + ', currentLevel=' + this.jdk_1.toString() + ', remainingLevels=' + toString(this.kdk_1) + ')';
  }
  hashCode() {
    var result = this.idk_1.hashCode();
    result = imul(result, 31) + this.jdk_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.kdk_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameSceneState))
      return false;
    var tmp0_other_with_cast = other instanceof GameSceneState ? other : THROW_CCE();
    if (!this.idk_1.equals(tmp0_other_with_cast.idk_1))
      return false;
    if (!this.jdk_1.equals(tmp0_other_with_cast.jdk_1))
      return false;
    if (!equals(this.kdk_1, tmp0_other_with_cast.kdk_1))
      return false;
    return true;
  }
}
class GameState extends Enum {}
class GameScene$sceneMain$slambda {
  constructor($gameState, $fieldView, this$0, $field) {
    this.tdj_1 = $gameState;
    this.udj_1 = $fieldView;
    this.vdj_1 = this$0;
    this.wdj_1 = $field;
  }
  ibb(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, it), $completion);
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$lambda$slambda {
  constructor($handler, $it) {
    this.ydk_1 = $handler;
    this.zdk_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class GameScene extends Scene {
  constructor(assetsLoader, state) {
    super();
    this.vdk_1 = assetsLoader;
    this.wdk_1 = state;
  }
  cdl() {
    var tmp = this.xdk_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('assets');
    }
  }
  qa9(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneInit__5zuhe0.bind(VOID, _this__u8e3s4, this), $completion);
  }
  ra9(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
class MainMenuScene$sceneMain$slambda {
  constructor(this$0) {
    this.qdl_1 = this$0;
  }
  ibb(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene$sceneMain$lambda$slambda {
  constructor($handler, $it) {
    this.rdl_1 = $handler;
    this.sdl_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class MainMenuScene$sceneMain$slambda_0 {
  constructor($codeBox) {
    this.ddm_1 = $codeBox;
  }
  ibb(it, $completion) {
    // Inline function 'korlibs.korge.view.visible' call
    var tmp;
    if (this.ddm_1._v == null) {
      throwUninitializedPropertyAccessException('codeBox');
    } else {
      tmp = this.ddm_1._v;
    }
    var this_0 = tmp;
    var tmp_0;
    if (this.ddm_1._v == null) {
      throwUninitializedPropertyAccessException('codeBox');
    } else {
      tmp_0 = this.ddm_1._v;
    }
    var visible = !tmp_0.val();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.visible.<anonymous>' call
    this_0.y8m(visible);
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene$sceneMain$lambda$slambda_0 {
  constructor($handler, $it) {
    this.tdl_1 = $handler;
    this.udl_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
  }
}
class MainMenuScene$sceneMain$slambda_1 {
  constructor($$this$mouse) {
    this.edm_1 = $$this$mouse;
  }
  ibb(it, $completion) {
    this.edm_1.qa0().j9n_1.h8n();
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene$sceneMain$lambda$slambda_1 {
  constructor($handler, $it) {
    this.vdl_1 = $handler;
    this.wdl_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class MainMenuScene$sceneMain$slambda_2 {
  constructor($really) {
    this.fdm_1 = $really;
  }
  ibb(it, $completion) {
    // Inline function 'korlibs.korge.view.visible' call
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.visible.<anonymous>' call
    this.fdm_1.y8m(true);
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene$sceneMain$lambda$slambda_2 {
  constructor($handler, $it) {
    this.xdl_1 = $handler;
    this.ydl_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class MainMenuScene$sceneMain$slambda_3 {
  constructor($input, this$0) {
    this.zdl_1 = $input;
    this.adm_1 = this$0;
  }
  ibb(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, it), $completion);
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene$sceneMain$lambda$slambda_3 {
  constructor($handler, $it) {
    this.bdm_1 = $handler;
    this.cdm_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
  }
}
class MainMenuScene extends Scene {
  qa9(_this__u8e3s4, $completion) {
  }
  ra9(_this__u8e3s4, $completion) {
    var codeBox = {_v: null};
    var codeButton = null;
    // Inline function 'korlibs.korge.ui.uiVerticalStack' call
    // Inline function 'kotlin.apply' call
    var this_0 = addTo(UIVerticalStack.ubq(null, 10.0, true), _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>' call
    // Inline function 'korlibs.korge.view.text' call
    var text = 'Plumbeteer';
    var color = Colors_getInstance().g41_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_7().q4z_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.fca_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Text.gca(text, numberToDouble(64), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.korge.ui.uiVerticalFill' call
    var size = Size2D.t26(128, 20);
    // Inline function 'kotlin.apply' call
    addTo(UIVerticalFill.rbw(size, numberToDouble(0.0)), this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.korge.ui.uiButton' call
    var label = 'New Game';
    var size_0 = Companion_getInstance_0().db1_1;
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(UIButton.rbb(size_0, label, null), this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
    centerXOn(this_2, this_0);
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var this_3 = get_mouse(this_2);
    var handler = MainMenuScene$sceneMain$slambda_4(this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp = click$factory_0().get(this_3);
    tmp.b1w(MainMenuScene$sceneMain$lambda(this_3, handler));
    // Inline function 'korlibs.korge.ui.uiButton' call
    var label_0 = 'Enter Code';
    var size_1 = Companion_getInstance_0().db1_1;
    // Inline function 'kotlin.apply' call
    var this_4 = addTo(UIButton.rbb(size_1, label_0, null), this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
    centerXOn(this_4, this_0);
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var this_5 = get_mouse(this_4);
    var handler_0 = MainMenuScene$sceneMain$slambda_5(codeBox);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_0 = click$factory_1().get(this_5);
    tmp_0.b1w(MainMenuScene$sceneMain$lambda_0(this_5, handler_0));
    codeButton = this_4;
    // Inline function 'korlibs.korge.ui.uiButton' call
    var size_2 = Companion_getInstance_0().db1_1;
    // Inline function 'kotlin.apply' call
    var this_6 = addTo(UIButton.rbb(size_2, 'Quit', null), this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
    centerXOn(this_6, this_0);
    var quit = this_6;
    // Inline function 'korlibs.korge.ui.uiButton' call
    var label_1 = 'Really Quit';
    var size_3 = Companion_getInstance_0().db1_1;
    // Inline function 'kotlin.apply' call
    var this_7 = addTo(UIButton.rbb(size_3, label_1, null), this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
    this_7.y8m(false);
    centerXOn(this_7, this_0);
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$mouse = get_mouse(this_7);
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var handler_1 = MainMenuScene$sceneMain$slambda_6($this$mouse);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_1 = click$factory_2().get($this$mouse);
    tmp_1.b1w(MainMenuScene$sceneMain$lambda_1($this$mouse, handler_1));
    var really = this_7;
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var this_8 = get_mouse(quit);
    var handler_2 = MainMenuScene$sceneMain$slambda_7(really);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_2 = click$factory_3().get(this_8);
    tmp_2.b1w(MainMenuScene$sceneMain$lambda_2(this_8, handler_2));
    centerOnStage(this_0);
    // Inline function 'korlibs.korge.ui.uiVerticalStack' call
    // Inline function 'kotlin.apply' call
    var this_9 = addTo(UIVerticalStack.ubq(null, 0.0, true), _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>' call
    // Inline function 'korlibs.korge.ui.uiTextInput' call
    var size_4 = Size2D.t26(128, 24);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.uiTextInput.<anonymous>' call
    // Inline function 'korlibs.korge.ui.uiTextInput.<anonymous>' call
    var input = addTo(UITextInput.qc7('CODE', size_4), this_9);
    // Inline function 'korlibs.korge.ui.uiButton' call
    var size_5 = Companion_getInstance_0().db1_1;
    // Inline function 'kotlin.apply' call
    var this_10 = addTo(UIButton.rbb(size_5, 'Submit', null), this_9);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.korge.input.onClickSuspend' call
    var handler_3 = MainMenuScene$sceneMain$slambda_8(input, this);
    // Inline function 'korlibs.korge.input.doMouseEventSuspend' call
    var prop = click$factory_4();
    // Inline function 'kotlin.js.getCoroutineContext' call
    var coroutineContext = $completion.rc();
    var tmp1_safe_receiver = this_10 == null ? null : this_10.gak();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEventSuspend.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_3 = prop.get(tmp1_safe_receiver_0);
          tmp_3.b1w(MainMenuScene$sceneMain$lambda_3(coroutineContext, tmp1_safe_receiver_0, handler_3));
        }
      }
    }
    var tmp_4;
    if (codeButton == null) {
      throwUninitializedPropertyAccessException('codeButton');
    } else {
      tmp_4 = codeButton;
    }
    alignLeftToRightOf(this_9, tmp_4, 10.0);
    var tmp_5;
    if (codeButton == null) {
      throwUninitializedPropertyAccessException('codeButton');
    } else {
      tmp_5 = codeButton;
    }
    alignTopToTopOf(this_9, tmp_5, 0.0);
    // Inline function 'korlibs.korge.view.visible' call
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.visible.<anonymous>' call
    this_9.y8m(false);
    codeBox._v = this_9;
  }
}
class AssetsLoader$get$slambda {
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class AssetsLoader {
  constructor() {
    this.adl_1 = null;
  }
  bdl($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_get__cbf6n6.bind(VOID, this), $completion);
  }
}
class Level {
  constructor(name, targetDistance, timerS, blockedTiles) {
    blockedTiles = blockedTiles === VOID ? 0 : blockedTiles;
    this.bdj_1 = name;
    this.cdj_1 = targetDistance;
    this.ddj_1 = timerS;
    this.edj_1 = blockedTiles;
    var tmp = this;
    tmp.fdj_1 = lazy(Level$code$delegate$lambda(this));
  }
  ddl() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.fdj_1;
    code$factory();
    return this_0.u1();
  }
  toString() {
    return 'Level(name=' + this.bdj_1 + ', targetDistance=' + this.cdj_1 + ', timerS=' + Duration__toString_impl_8d916b(this.ddj_1) + ', blockedTiles=' + this.edj_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.bdj_1);
    result = imul(result, 31) + this.cdj_1 | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.ddj_1) | 0;
    result = imul(result, 31) + this.edj_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Level))
      return false;
    var tmp0_other_with_cast = other instanceof Level ? other : THROW_CCE();
    if (!(this.bdj_1 === tmp0_other_with_cast.bdj_1))
      return false;
    if (!(this.cdj_1 === tmp0_other_with_cast.cdj_1))
      return false;
    if (!equals(this.ddj_1, tmp0_other_with_cast.ddj_1))
      return false;
    if (!(this.edj_1 === tmp0_other_with_cast.edj_1))
      return false;
    return true;
  }
}
class main$slambda {
  y9j($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$Korge), $completion);
  }
  vd(p1, $completion) {
    return this.y9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Tile {}
class BlockedTile extends Tile {
  mdj(dt) {
    return null;
  }
  qdj(direction, dt) {
    return false;
  }
  sdj() {
    return false;
  }
  toString() {
    return 'BlockedTile()';
  }
}
class CornerPipe extends Tile {
  constructor(length, direction) {
    super();
    this.qdm_1 = length;
    this.rdm_1 = direction;
    var tmp = this;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp.sdm_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    this.tdm_1 = null;
    this.udm_1 = false;
  }
  mdj(dt) {
    if (!(this.tdm_1 == null)) {
      if (!this.udm_1) {
        this.sdm_1 = Duration__plus_impl_yu9v8f(this.sdm_1, dt);
      }
      if (!this.udm_1 && !(this.tdm_1 == null) && Duration__compareTo_impl_pchp0f(this.sdm_1, this.qdm_1) > 0) {
        this.udm_1 = true;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.first' call
          var tmp0_iterator = validDirections(this).a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'tile.CornerPipe.onUpdate.<anonymous>' call
            if (!element.equals(this.tdm_1)) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          throw NoSuchElementException.p('Collection contains no element matching the predicate.');
        }
        var outputDirection = tmp$ret$1;
        return new Overflow(Duration__minus_impl_q5cfm7(this.sdm_1, this.qdm_1), outputDirection, new Long(1000, 0));
      }
    }
    return null;
  }
  qdj(direction, dt) {
    var tmp;
    if (!(this.tdm_1 == null)) {
      tmp = false;
    } else if (validDirections(this).z2(direction.bdi())) {
      this.tdm_1 = direction.bdi();
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  sdj() {
    return this.tdm_1 == null;
  }
  toString() {
    return 'CornerPipe(direction=' + this.rdm_1.toString() + ', elapsed=' + Duration__toString_impl_8d916b(this.sdm_1) + ', liquidDirection=' + toString_1(this.tdm_1) + ')';
  }
}
class Inner {
  constructor(length, orientation) {
    this.vdm_1 = length;
    this.wdm_1 = orientation;
    var tmp = this;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp.xdm_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    this.ydm_1 = null;
    this.zdm_1 = false;
  }
  mdj(dt) {
    if (!(this.ydm_1 == null)) {
      if (!this.zdm_1) {
        this.xdm_1 = Duration__plus_impl_yu9v8f(this.xdm_1, dt);
      }
      if (!this.zdm_1 && !(this.ydm_1 == null) && Duration__compareTo_impl_pchp0f(this.xdm_1, this.vdm_1) > 0) {
        this.zdm_1 = true;
        return new Overflow(Duration__minus_impl_q5cfm7(this.xdm_1, this.vdm_1), ensureNotNull(this.ydm_1), new Long(1000, 0));
      }
    }
    return null;
  }
  qdj(direction, dt) {
    var tmp;
    if (!(this.ydm_1 == null)) {
      tmp = false;
    } else if (this.wdm_1.gdi_1.z2(direction)) {
      this.ydm_1 = direction;
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class CrossPipe extends Tile {
  constructor(length) {
    super();
    this.adn_1 = mapOf([to(Orientation_VERTICAL_getInstance(), new Inner(length, Orientation_VERTICAL_getInstance())), to(Orientation_HORIZONTAL_getInstance(), new Inner(length, Orientation_HORIZONTAL_getInstance()))]);
  }
  mdj(dt) {
    var ret = null;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.adn_1.s1().a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'tile.CrossPipe.onUpdate.<anonymous>' call
      var tmp0_elvis_lhs = element.u1().mdj(dt);
      ret = tmp0_elvis_lhs == null ? ret : tmp0_elvis_lhs;
    }
    var tmp;
    var tmp_0;
    if (ret instanceof Overflow) {
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var this_0 = this.adn_1;
        if (this_0.g1()) {
          tmp$ret$1 = true;
          break $l$block_0;
        }
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_0 = this_0.s1().a1();
        while (tmp0_iterator_0.b1()) {
          var element_0 = tmp0_iterator_0.c1();
          // Inline function 'tile.CrossPipe.onUpdate.<anonymous>' call
          if (!element_0.u1().zdm_1) {
            tmp$ret$1 = false;
            break $l$block_0;
          }
        }
        tmp$ret$1 = true;
      }
      tmp_0 = tmp$ret$1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_1 = (ret instanceof Overflow ? ret : THROW_CCE()).ndj_1;
      tmp = new Overflow(tmp_1, (ret instanceof Overflow ? ret : THROW_CCE()).odj_1, new Long(5000, 0));
    } else {
      tmp = ret;
    }
    return tmp;
  }
  qdj(direction, dt) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this.adn_1;
      if (this_0.g1()) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = this_0.s1().a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'tile.CrossPipe.takeLiquid.<anonymous>' call
        if (element.u1().qdj(direction, dt)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  sdj() {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var this_0 = this.adn_1.h3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'tile.CrossPipe.isEditable.<anonymous>' call
        if (!(element.ydm_1 == null)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
}
class EmptyTile extends Tile {
  mdj(dt) {
    return null;
  }
  qdj(direction, dt) {
    return false;
  }
  sdj() {
    return true;
  }
}
class StartPipe extends Tile {
  constructor(length, direction) {
    super();
    this.hdj_1 = length;
    this.idj_1 = direction;
    var tmp = this;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp.jdj_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    this.kdj_1 = null;
    this.ldj_1 = false;
  }
  mdj(dt) {
    if (!(this.kdj_1 == null)) {
      if (!this.ldj_1) {
        println(this);
        this.jdj_1 = Duration__plus_impl_yu9v8f(this.jdj_1, dt);
      }
      if (!this.ldj_1 && !(this.kdj_1 == null) && Duration__compareTo_impl_pchp0f(this.jdj_1, this.hdj_1) > 0) {
        this.ldj_1 = true;
        return new Overflow(Duration__minus_impl_q5cfm7(this.jdj_1, this.hdj_1), this.idj_1, new Long(0, 0));
      }
    }
    return null;
  }
  qdj(direction, dt) {
    return false;
  }
  sdj() {
    return false;
  }
  toString() {
    return 'StartPipe(direction=' + this.idj_1.toString() + ', elapsed=' + Duration__toString_impl_8d916b(this.jdj_1) + ', liquidDirection=' + toString_1(this.kdj_1) + ')';
  }
  gdj() {
    this.kdj_1 = this.idj_1;
  }
}
class StraightPipe extends Tile {
  constructor(length, orientation) {
    super();
    this.bdn_1 = length;
    this.cdn_1 = orientation;
    var tmp = this;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp.ddn_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    this.edn_1 = null;
    this.fdn_1 = false;
  }
  mdj(dt) {
    if (!(this.edn_1 == null)) {
      if (!this.fdn_1) {
        this.ddn_1 = Duration__plus_impl_yu9v8f(this.ddn_1, dt);
      }
      if (!this.fdn_1 && !(this.edn_1 == null) && Duration__compareTo_impl_pchp0f(this.ddn_1, this.bdn_1) > 0) {
        this.fdn_1 = true;
        return new Overflow(Duration__minus_impl_q5cfm7(this.ddn_1, this.bdn_1), ensureNotNull(this.edn_1), new Long(1000, 0));
      }
    }
    return null;
  }
  qdj(direction, dt) {
    var tmp;
    if (!(this.edn_1 == null)) {
      tmp = false;
    } else if (this.cdn_1.gdi_1.z2(direction)) {
      this.edn_1 = direction;
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  sdj() {
    return this.edn_1 == null;
  }
}
class Overflow {
  constructor(dt, direction, score) {
    this.ndj_1 = dt;
    this.odj_1 = direction;
    this.pdj_1 = score;
    println(this);
  }
  toString() {
    return 'Overflow(dt=' + Duration__toString_impl_8d916b(this.ndj_1) + ', direction=' + this.odj_1.toString() + ', score=' + this.pdj_1.toString() + ')';
  }
  hashCode() {
    var result = Duration__hashCode_impl_u4exz6(this.ndj_1);
    result = imul(result, 31) + this.odj_1.hashCode() | 0;
    result = imul(result, 31) + this.pdj_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Overflow))
      return false;
    var tmp0_other_with_cast = other instanceof Overflow ? other : THROW_CCE();
    if (!equals(this.ndj_1, tmp0_other_with_cast.ndj_1))
      return false;
    if (!this.odj_1.equals(tmp0_other_with_cast.odj_1))
      return false;
    if (!this.pdj_1.equals(tmp0_other_with_cast.pdj_1))
      return false;
    return true;
  }
}
class Particle {
  constructor(position, velocity, acceleration, angle, angularVelocity, view, lifetime) {
    this.gdn_1 = position;
    this.hdn_1 = velocity;
    this.idn_1 = acceleration;
    this.jdn_1 = angle;
    this.kdn_1 = angularVelocity;
    this.ldn_1 = view;
    this.mdn_1 = lifetime;
  }
  toString() {
    return 'Particle(position=' + this.gdn_1.toString() + ', velocity=' + this.hdn_1.toString() + ', acceleration=' + this.idn_1.toString() + ', angle=' + Angle__toString_impl_786qky(this.jdn_1) + ', angularVelocity=' + Angle__toString_impl_786qky(this.kdn_1) + ', view=' + this.ldn_1.toString() + ', lifetime=' + Duration__toString_impl_8d916b(this.mdn_1) + ')';
  }
  hashCode() {
    var result = this.gdn_1.hashCode();
    result = imul(result, 31) + this.hdn_1.hashCode() | 0;
    result = imul(result, 31) + this.idn_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.jdn_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.kdn_1) | 0;
    result = imul(result, 31) + hashCode(this.ldn_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.mdn_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Particle))
      return false;
    var tmp0_other_with_cast = other instanceof Particle ? other : THROW_CCE();
    if (!this.gdn_1.equals(tmp0_other_with_cast.gdn_1))
      return false;
    if (!this.hdn_1.equals(tmp0_other_with_cast.hdn_1))
      return false;
    if (!this.idn_1.equals(tmp0_other_with_cast.idn_1))
      return false;
    if (!equals(this.jdn_1, tmp0_other_with_cast.jdn_1))
      return false;
    if (!equals(this.kdn_1, tmp0_other_with_cast.kdn_1))
      return false;
    if (!equals(this.ldn_1, tmp0_other_with_cast.ldn_1))
      return false;
    if (!equals(this.mdn_1, tmp0_other_with_cast.mdn_1))
      return false;
    return true;
  }
}
class Particles {
  constructor(assets, sContainer, viewRectangle) {
    this.edl_1 = assets;
    this.fdl_1 = sContainer;
    this.gdl_1 = viewRectangle;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.hdl_1 = ArrayList.h1();
  }
  idl(particle) {
    this.hdl_1.h(particle);
  }
  nda(dt) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var toRemove = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.hdl_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'view.Particles.update.<anonymous>' call
      var tmp = element;
      // Inline function 'korlibs.math.geom.Vector2F.plus' call
      var this_0 = element.gdn_1;
      var that = times(get_seconds(dt), element.hdn_1);
      tmp.gdn_1 = Vector2F.p2i(this_0.q2e_1 + that.q2e_1, this_0.r2e_1 + that.r2e_1);
      var tmp_0 = element;
      // Inline function 'korlibs.math.geom.Vector2F.plus' call
      var this_1 = element.hdn_1;
      var that_0 = times(get_seconds(dt), element.idn_1);
      tmp_0.hdn_1 = Vector2F.p2i(this_1.q2e_1 + that_0.q2e_1, this_1.r2e_1 + that_0.r2e_1);
      element.jdn_1 = Angle__plus_impl_26v37k(element.jdn_1, Angle__times_impl_v3s9y2(element.kdn_1, get_seconds(dt)));
      element.mdn_1 = Duration__minus_impl_q5cfm7(element.mdn_1, dt);
      element.ldn_1.tak(element.gdn_1.q2e_1 - element.ldn_1.z2i() * 0.5);
      element.ldn_1.uak(element.gdn_1.r2e_1 - element.ldn_1.a2j() * 0.5);
      element.ldn_1.gal(element.jdn_1);
      var tmp_1 = element.mdn_1;
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$4 = toDuration_0(0, DurationUnit_SECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(tmp_1, tmp$ret$4) <= 0) {
        toRemove.h(element);
      }
      if (!this.gdl_1.p2e(element.gdn_1)) {
        toRemove.h(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = toRemove.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'view.Particles.update.<anonymous>' call
      element_0.ldn_1.qam();
    }
    this.hdl_1.n3(toRemove);
  }
}
class PlayFieldView {
  constructor(playField, assets, sContainer, viewRectangle, views, isActiveCallback) {
    this.xdj_1 = playField;
    this.ydj_1 = assets;
    this.zdj_1 = sContainer;
    this.adk_1 = viewRectangle;
    this.bdk_1 = views;
    this.cdk_1 = isActiveCallback;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration_0(0, DurationUnit_SECONDS_getInstance());
    tmp.ddk_1 = get_fast(tmp$ret$1);
    this.edk_1 = Companion_getInstance_8().qw(ensureNotNull(getKClassFromExpression(this).ye()));
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.fdk_1 = ArrayList.h1();
    this.gdk_1 = Size2D.l2e(this.adk_1.y25_1 / this.xdj_1.rdi_1, this.adk_1.z25_1 / this.xdj_1.sdi_1);
  }
  nda(dt) {
    this.ddk_1 = FastDuration__plus_impl_q1enab(this.ddk_1, get_fast(dt));
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.fdk_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'view.PlayFieldView.update.<anonymous>' call
      element.qam();
    }
    this.fdk_1.l3();
    var currentMousePos = this.zdj_1.bam(this.bdk_1);
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator_0 = this.xdj_1.xdi_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'view.PlayFieldView.update.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var x = checkIndexOverflow(tmp1);
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index_0 = 0;
      var tmp0_iterator_1 = item.a1();
      while (tmp0_iterator_1.b1()) {
        var item_0 = tmp0_iterator_1.c1();
        // Inline function 'view.PlayFieldView.update.<anonymous>.<anonymous>' call
        var tmp1_0 = index_0;
        index_0 = tmp1_0 + 1 | 0;
        var y = checkIndexOverflow(tmp1_0);
        var tilePos = Vector2F.q2i(this.adk_1.w25_1 + x * this.gdk_1.r26_1, this.adk_1.x25_1 + y * this.gdk_1.s26_1);
        // Inline function 'korlibs.math.geom.Companion.invoke' call
        Companion_getInstance_3();
        var x_0 = tilePos.q2e_1;
        var y_0 = tilePos.r2e_1;
        var width = this.gdk_1.r26_1;
        var height = this.gdk_1.s26_1;
        var tmp = Companion_getInstance_3();
        // Inline function 'korlibs.math.geom.Companion.invoke' call
        Companion_getInstance_5();
        var tmp_0 = Vector2D.w27(numberToDouble(x_0), numberToDouble(y_0));
        // Inline function 'korlibs.math.geom.Companion.invoke' call
        Companion_getInstance_2();
        var tmp$ret$1 = Size2D.l2e(numberToDouble(width), numberToDouble(height));
        var tileRect = tmp.u26(tmp_0, tmp$ret$1);
        var hover = !this.bdk_1.g9n_1.t87() && this.cdk_1() && tileRect.s27(currentMousePos);
        // Inline function 'korlibs.korge.view.sprite' call
        var this_0 = this.zdj_1;
        var texture = this.ydj_1.mdh_1;
        var anchor = Companion_getInstance_4().n24_1;
        // Inline function 'korlibs.korge.view.addTo' call
        var this_1 = Sprite.ud8(texture, anchor);
        // Inline function 'kotlin.apply' call
        var this_2 = addTo(this_1, this_0);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'view.PlayFieldView.update.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'korlibs.korge.view.position' call
        var x_1 = tilePos.q2e_1;
        var y_1 = tilePos.r2e_1;
        xy(this_2, numberToDouble(x_1), numberToDouble(y_1));
        size(this_2, this.gdk_1);
        if (hover) {
          // Inline function 'kotlin.math.abs' call
          // Inline function 'kotlin.math.sin' call
          var x_2 = _FastDuration___get_milliseconds__impl__ffr17u(this.ddk_1) * 0.002;
          var x_3 = Math.sin(x_2);
          var ratio = 0.5 * Math.abs(x_3);
          // Inline function 'korlibs.image.color.ColorTransform' call
          var multiply = RGBA__interpolateWith_impl_mw7p5y(Colors_getInstance().g41_1, _Ratio___init__impl__9mwvn2(ratio), Colors_getInstance().e41_1);
          // Inline function 'korlibs.image.color.Companion.invoke' call
          var add = _ColorAdd___init__impl__q78um5(ColorAdd_pack(0, 0, 0, 0));
          var tmp$ret$7 = new ColorTransform(_RGBA___get_rf__impl__kvz75k(multiply), _RGBA___get_gf__impl__5gcu1f(multiply), _RGBA___get_bf__impl__1xz5yg(multiply), _RGBA___get_af__impl__vu36qv(multiply), _ColorAdd___get_r__impl__j9xkne(add), _ColorAdd___get_g__impl__itrhk1(add), _ColorAdd___get_b__impl__grv87a(add), _ColorAdd___get_a__impl__c1r8ux(add));
          addFilter(this_2, new ColorTransformFilter(tmp$ret$7));
        }
        this.fdk_1.h(this_2);
        if (!(item_0 instanceof EmptyTile)) {
          if (item_0 instanceof CornerPipe) {
            cornerPipe(this, item_0, tileRect);
          } else {
            if (item_0 instanceof CrossPipe) {
              crossPipe(this, item_0, tileRect);
            } else {
              if (item_0 instanceof StartPipe) {
                startPipe(this, item_0, tileRect);
              } else {
                if (item_0 instanceof StraightPipe) {
                  straightPipe(this, item_0, tileRect);
                } else {
                  if (item_0 instanceof BlockedTile) {
                    blockedTile(this, tileRect);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  hdk(it) {
    var clickPos = it.wa0();
    if (this.adk_1.s27(clickPos)) {
      var indexX = (clickPos.m25_1 - this.adk_1.w25_1) / this.gdk_1.r26_1;
      var indexY = (clickPos.n25_1 - this.adk_1.x25_1) / this.gdk_1.s26_1;
      this.xdj_1.rdj(numberToInt(indexX), numberToInt(indexY));
    } else {
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_0 = this.edk_1;
      var level = Level_DEBUG_getInstance();
      var tmp;
      if (this_0.a2u(level)) {
        // Inline function 'view.PlayFieldView.onClick.<anonymous>' call
        var tmp$ret$0 = 'ignoring click outside view.PlayFieldView at ' + clickPos.toString();
        this_0.b2u(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
  }
}
class StagingAreaView {
  constructor(stagingArea, assets, sContainer, viewRectangle) {
    this.jdl_1 = stagingArea;
    this.kdl_1 = assets;
    this.ldl_1 = sContainer;
    this.mdl_1 = viewRectangle;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ndl_1 = ArrayList.h1();
    this.odl_1 = Size2D.l2e(this.mdl_1.y25_1, this.mdl_1.z25_1 / this.jdl_1.ndi_1);
    var tmp_0 = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration_0(0, DurationUnit_SECONDS_getInstance());
    tmp_0.pdl_1 = get_fast(tmp$ret$2);
  }
  oda(dt) {
    this.pdl_1 = FastDuration__plus_impl_q1enab(this.pdl_1, dt);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.ndl_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'view.StagingAreaView.update.<anonymous>' call
      element.qam();
    }
    this.ndl_1.l3();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator_0 = this.jdl_1.mdi_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'view.StagingAreaView.update.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var y = checkIndexOverflow(tmp1);
      var tilePos = Vector2F.q2i(this.mdl_1.w25_1, this.mdl_1.x25_1 + y * this.odl_1.s26_1);
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_3();
      var x = tilePos.q2e_1;
      var y_0 = tilePos.r2e_1;
      var width = this.odl_1.r26_1;
      var height = this.odl_1.s26_1;
      var tmp = Companion_getInstance_3();
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_5();
      var tmp_0 = Vector2D.w27(numberToDouble(x), numberToDouble(y_0));
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_2();
      var tmp$ret$1 = Size2D.l2e(numberToDouble(width), numberToDouble(height));
      var tileRect = tmp.u26(tmp_0, tmp$ret$1);
      // Inline function 'korlibs.korge.view.sprite' call
      var this_0 = this.ldl_1;
      var texture = this.kdl_1.mdh_1;
      var anchor = Companion_getInstance_4().n24_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Sprite.ud8(texture, anchor);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, this_0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'view.StagingAreaView.update.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.position' call
      var x_0 = tilePos.q2e_1;
      var y_1 = tilePos.r2e_1;
      xy(this_2, numberToDouble(x_0), numberToDouble(y_1));
      size(this_2, this.odl_1);
      this.ndl_1.h(this_2);
      var tmp_1;
      if (item instanceof EmptyTile) {
        tmp_1 = null;
      } else {
        if (item instanceof BlockedTile) {
          tmp_1 = null;
        } else {
          if (item instanceof CornerPipe) {
            tmp_1 = baseCornerPipe(this.ldl_1, this.kdl_1, tileRect, item);
          } else {
            if (item instanceof CrossPipe) {
              tmp_1 = baseCrossPipe(this.ldl_1, this.kdl_1, tileRect, item);
            } else {
              if (item instanceof StartPipe) {
                tmp_1 = null;
              } else {
                if (item instanceof StraightPipe) {
                  tmp_1 = baseStraigthPipe(this.ldl_1, this.kdl_1, tileRect, item);
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
      }
      var tmp1_safe_receiver = tmp_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.ndl_1.h(tmp1_safe_receiver);
      }
    }
    // Inline function 'korlibs.korge.view.sprite' call
    var this_3 = this.ldl_1;
    var initialAnimation = this.kdl_1.wdh_1;
    var anchor_0 = Companion_getInstance_4().n24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Sprite.vd8(initialAnimation, anchor_0);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'view.StagingAreaView.update.<anonymous>' call
    position(this_5, this.mdl_1.w25_1, this.mdl_1.x25_1);
    size(this_5, this.odl_1);
    this_5.xd8(numberToInt(_FastDuration___get_fastMilliseconds__impl__pe68va(this.pdl_1) * 0.01) % 5 | 0);
    this.ndl_1.h(this_5);
  }
}
//endregion
var Direction_UP_instance;
var Direction_DOWN_instance;
var Direction_LEFT_instance;
var Direction_RIGHT_instance;
function values() {
  return [Direction_UP_getInstance(), Direction_DOWN_getInstance(), Direction_LEFT_getInstance(), Direction_RIGHT_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_UP_instance = new Direction('UP', 0, Vector2I.t2f(0, -1), _Char___init__impl__6a9atx(8593));
  Direction_DOWN_instance = new Direction('DOWN', 1, Vector2I.t2f(0, 1), _Char___init__impl__6a9atx(8595));
  Direction_LEFT_instance = new Direction('LEFT', 2, Vector2I.t2f(-1, 0), _Char___init__impl__6a9atx(8592));
  Direction_RIGHT_instance = new Direction('RIGHT', 3, Vector2I.t2f(1, 0), _Char___init__impl__6a9atx(8594));
}
var $ENTRIES;
var Orientation_HORIZONTAL_instance;
var Orientation_VERTICAL_instance;
var Companion_instance_1;
function Companion_getInstance_9() {
  return Companion_instance_1;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_HORIZONTAL_instance = new Orientation('HORIZONTAL', 0, listOf_0([Direction_LEFT_getInstance(), Direction_RIGHT_getInstance()]));
  Orientation_VERTICAL_instance = new Orientation('VERTICAL', 1, listOf_0([Direction_UP_getInstance(), Direction_DOWN_getInstance()]));
}
function Direction_UP_getInstance() {
  Direction_initEntries();
  return Direction_UP_instance;
}
function Direction_DOWN_getInstance() {
  Direction_initEntries();
  return Direction_DOWN_instance;
}
function Direction_LEFT_getInstance() {
  Direction_initEntries();
  return Direction_LEFT_instance;
}
function Direction_RIGHT_getInstance() {
  Direction_initEntries();
  return Direction_RIGHT_instance;
}
function Orientation_HORIZONTAL_getInstance() {
  Orientation_initEntries();
  return Orientation_HORIZONTAL_instance;
}
function Orientation_VERTICAL_getInstance() {
  Orientation_initEntries();
  return Orientation_VERTICAL_instance;
}
function StagingArea$generators$lambda() {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
  return new StraightPipe(tmp$ret$0, Orientation_VERTICAL_getInstance());
}
function StagingArea$generators$lambda_0() {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
  return new StraightPipe(tmp$ret$0, Orientation_HORIZONTAL_getInstance());
}
function StagingArea$generators$lambda_1() {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
  return new CornerPipe(tmp$ret$0, Direction_UP_getInstance());
}
function StagingArea$generators$lambda_2() {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
  return new CornerPipe(tmp$ret$0, Direction_DOWN_getInstance());
}
function StagingArea$generators$lambda_3() {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
  return new CornerPipe(tmp$ret$0, Direction_LEFT_getInstance());
}
function StagingArea$generators$lambda_4() {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
  return new CornerPipe(tmp$ret$0, Direction_RIGHT_getInstance());
}
function StagingArea$generators$lambda_5() {
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
  return new CrossPipe(tmp$ret$0);
}
function overOrNextLevel($this) {
  return $this.adj_1 <= 0 ? new NextLevel($this.vdi_1) : new GameOver($this.vdi_1);
}
function getTileOrNull($this, vec) {
  var tmp0_safe_receiver = getOrNull($this.xdi_1, vec.q2f_1);
  return tmp0_safe_receiver == null ? null : getOrNull(tmp0_safe_receiver, vec.r2f_1);
}
var GameState_PLAY_instance;
var GameState_GAME_OVER_instance;
var GameState_NEXT_LEVEL_instance;
var GameState_GAME_WON_instance;
var GameState_entriesInitialized;
function GameState_initEntries() {
  if (GameState_entriesInitialized)
    return Unit_instance;
  GameState_entriesInitialized = true;
  GameState_PLAY_instance = new GameState('PLAY', 0);
  GameState_GAME_OVER_instance = new GameState('GAME_OVER', 1);
  GameState_NEXT_LEVEL_instance = new GameState('NEXT_LEVEL', 2);
  GameState_GAME_WON_instance = new GameState('GAME_WON', 3);
}
function *_generator_invoke__zhh2q8($this, it, $completion) {
  switch ($this.tdj_1._v.r3_1) {
    case 0:
      $this.udj_1.hdk(it);
      break;
    case 1:
    case 3:
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call

      var this_0 = $this.vdj_1.qa4();
      var injects = [];
      // Inline function 'korlibs.time.seconds' call

      // Inline function 'korlibs.time.seconds' call

      var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
      var transition = this_0.l9u_1;
      var tmp = this_0.nag(getKClass(MainMenuScene), injects.slice(), time, transition, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      break;
    case 2:
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call

      var this_1 = $this.vdj_1.qa4();
      var injects_0 = [new GameSceneState($this.wdj_1.vdi_1, first($this.vdj_1.wdk_1.kdk_1), drop($this.vdj_1.wdk_1.kdk_1, 1))];
      // Inline function 'korlibs.time.seconds' call

      // Inline function 'korlibs.time.seconds' call

      var time_0 = toDuration_0(0, DurationUnit_SECONDS_getInstance());
      var transition_0 = this_1.l9u_1;
      var tmp_0 = this_1.nag(getKClass(GameScene), injects_0.slice(), time_0, transition_0, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.ydk_1($this.zdk_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_sceneInit__5zuhe0(_this__u8e3s4, $this, $completion) {
  var tmp = $this;
  var tmp_0 = $this.vdk_1.bdl($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.xdk_1 = tmp_0;
  return Unit_instance;
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  var startDuration = $this.wdk_1.jdk_1.ddj_1;
  var startTimer = {_v: new Duration(startDuration)};
  var started = {_v: false};
  var gameState = {_v: GameState_PLAY_getInstance()};
  var tileWidth = 40;
  var tileHeight = 40;
  var fieldCountX = 10;
  var fieldCountY = 10;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_6()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_2().p2g_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp = views($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var views_0 = tmp;
  var width = size.jl();
  var height = size.kl();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_0 = findFirstAscendant(_this__u8e3s4, GameScene$sceneMain$lambda);
    var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
    var tmp1_elvis_lhs = base == null ? null : base.z2i();
    rwidth = tmp1_elvis_lhs == null ? views_0.p9o_1.z2i() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.a2j();
    rheight = tmp3_elvis_lhs == null ? views_0.p9o_1.a2j() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.q9u(views_0, defaultTransition, name, Size2D.l2e(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var fieldLayer = addTo(this_0, _this__u8e3s4);
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition_0 = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_6()));
  var name_0 = 'sceneContainer';
  var size_0 = Companion_getInstance_2().p2g_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp_1 = views($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var views_1 = tmp_1;
  var width_0 = size_0.jl();
  var height_0 = size_0.kl();
  var rwidth_0 = width_0;
  var rheight_0 = height_0;
  if (width_0 === 0.0 && height_0 === 0.0) {
    var tmp_2 = findFirstAscendant(_this__u8e3s4, GameScene$sceneMain$lambda_0);
    var base_0 = (tmp_2 == null ? true : tmp_2 instanceof FixedSizeContainer) ? tmp_2 : null;
    var tmp1_elvis_lhs_0 = base_0 == null ? null : base_0.z2i();
    rwidth_0 = tmp1_elvis_lhs_0 == null ? views_1.p9o_1.z2i() : tmp1_elvis_lhs_0;
    var tmp3_elvis_lhs_0 = base_0 == null ? null : base_0.a2j();
    rheight_0 = tmp3_elvis_lhs_0 == null ? views_1.p9o_1.a2j() : tmp3_elvis_lhs_0;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = SceneContainer.q9u(views_1, defaultTransition_0, name_0, Size2D.l2e(rwidth_0, rheight_0));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var particleLayer = addTo(this_1, _this__u8e3s4);
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition_1 = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_6()));
  var name_1 = 'sceneContainer';
  var size_1 = Companion_getInstance_2().p2g_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp_3 = views($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var views_2 = tmp_3;
  var width_1 = size_1.jl();
  var height_1 = size_1.kl();
  var rwidth_1 = width_1;
  var rheight_1 = height_1;
  if (width_1 === 0.0 && height_1 === 0.0) {
    var tmp_4 = findFirstAscendant(_this__u8e3s4, GameScene$sceneMain$lambda_1);
    var base_1 = (tmp_4 == null ? true : tmp_4 instanceof FixedSizeContainer) ? tmp_4 : null;
    var tmp1_elvis_lhs_1 = base_1 == null ? null : base_1.z2i();
    rwidth_1 = tmp1_elvis_lhs_1 == null ? views_2.p9o_1.z2i() : tmp1_elvis_lhs_1;
    var tmp3_elvis_lhs_1 = base_1 == null ? null : base_1.a2j();
    rheight_1 = tmp3_elvis_lhs_1 == null ? views_2.p9o_1.a2j() : tmp3_elvis_lhs_1;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SceneContainer.q9u(views_2, defaultTransition_1, name_1, Size2D.l2e(rwidth_1, rheight_1));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var topLayer = addTo(this_2, _this__u8e3s4);
  // Inline function 'kotlin.also' call
  var this_3 = new StagingArea();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  this_3.qdi();
  var staging = this_3;
  var viewRectangle = Companion_getInstance_3().e2e(0, 0, imul(tileWidth, fieldCountX), imul(tileHeight, fieldCountY));
  var particles = new Particles($this.cdl(), particleLayer, viewRectangle);
  var field = new PlayField(fieldCountX, fieldCountY, staging, $this.wdk_1.jdk_1, VOID, GameScene$sceneMain$lambda_2(tileWidth, tileHeight, particles, particleLayer));
  // Inline function 'korlibs.korge.view.text' call
  var color = Colors_getInstance().e41_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_7().q4z_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.fca_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Text.gca('NEXT:', numberToDouble(16), color, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.position' call
  xy(this_5, numberToDouble(450), numberToDouble(4));
  var stagingView = new StagingAreaView(staging, $this.cdl(), fieldLayer, Companion_getInstance_3().e2e(450, 24, tileWidth, imul(5, tileHeight)));
  var tmp_5 = $this.cdl();
  var tmp_6 = $this.qa0();
  var fieldView = new PlayFieldView(field, tmp_5, fieldLayer, viewRectangle, tmp_6, GameScene$sceneMain$lambda_3(gameState));
  // Inline function 'korlibs.korge.view.text' call
  var text = 'SCORE: 0';
  var color_0 = Colors_getInstance().e41_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment_0 = Companion_getInstance_7().q4z_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.fca_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = Text.gca(text, numberToDouble(24), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.position' call
  xy(this_7, numberToDouble(10), numberToDouble(410));
  var scoreView = this_7;
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = 'DISTANCE: 0';
  var color_1 = Colors_getInstance().e41_1;
  var font_1 = get_DefaultTtfFontAsBitmap();
  var alignment_1 = Companion_getInstance_7().q4z_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance.fca_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_8 = Text.gca(text_0, numberToDouble(24), color_1, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_9 = addTo(this_8, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.position' call
  xy(this_9, numberToDouble(210), numberToDouble(410));
  var distanceView = this_9;
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = 'LEVEL: ' + $this.wdk_1.jdk_1.bdj_1;
  var color_2 = Colors_getInstance().u46_1;
  var font_2 = get_DefaultTtfFontAsBitmap();
  var alignment_2 = Companion_getInstance_7().q4z_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance.fca_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_10 = Text.gca(text_1, numberToDouble(24), color_2, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_11 = addTo(this_10, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.position' call
  xy(this_11, numberToDouble(10), numberToDouble(432));
  // Inline function 'korlibs.korge.view.text' call
  var text_2 = 'CODE: ' + $this.wdk_1.jdk_1.ddl();
  var color_3 = Colors_getInstance().e41_1;
  var font_3 = get_DefaultTtfFontAsBitmap();
  var alignment_3 = Companion_getInstance_7().q4z_1;
  var renderer_3 = get_DefaultStringTextRenderer();
  var autoScaling_3 = Companion_instance.fca_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_12 = Text.gca(text_2, numberToDouble(24), color_3, font_3, alignment_3, renderer_3, autoScaling_3, null, null);
  // Inline function 'kotlin.apply' call
  var this_13 = addTo(this_12, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.position' call
  xy(this_13, numberToDouble(10), numberToDouble(454));
  var gameFinalizedView = {_v: null};
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_4 = Colors_getInstance().h41_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_14 = SolidRect.pd5(Size2D.t26(30, 200), color_4);
  // Inline function 'kotlin.apply' call
  var this_15 = addTo(this_14, topLayer);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.position' call
  xy(this_15, numberToDouble(410), numberToDouble(24));
  var startTimerView = this_15;
  // Inline function 'korlibs.korge.view.text' call
  var color_5 = Colors_getInstance().e41_1;
  var font_4 = get_DefaultTtfFontAsBitmap();
  var alignment_4 = Companion_getInstance_7().q4z_1;
  var renderer_4 = get_DefaultStringTextRenderer();
  var autoScaling_4 = Companion_instance.fca_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_16 = Text.gca('', numberToDouble(16), color_5, font_4, alignment_4, renderer_4, autoScaling_4, null, null);
  // Inline function 'kotlin.apply' call
  var this_17 = addTo(this_16, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.position' call
  xy(this_17, numberToDouble(410), numberToDouble(4));
  var startTimerText = this_17;
  addUpdater(_this__u8e3s4, GameScene$sceneMain$lambda_4(field, gameState, $this, fieldView, stagingView, particles, scoreView, distanceView, started, startTimer, startDuration, startTimerView, startTimerText, gameFinalizedView, topLayer));
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
  var this_18 = get_mouse(_this__u8e3s4);
  var handler = GameScene$sceneMain$slambda_0(gameState, fieldView, $this, field);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_7 = click$factory().get(this_18);
  tmp_7.b1w(GameScene$sceneMain$lambda_5(this_18, handler));
  return Unit_instance;
}
function GameScene$sceneMain$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function GameScene$sceneMain$lambda_0(it) {
  return it instanceof FixedSizeContainer;
}
function GameScene$sceneMain$lambda_1(it) {
  return it instanceof FixedSizeContainer;
}
function GameScene$sceneMain$lambda_2($tileWidth, $tileHeight, $particles, $particleLayer) {
  return function (it) {
    var tmp;
    if (it instanceof Scored) {
      var position = Vector2F.q2i(imul(it.jdi_1, $tileWidth) + $tileWidth * 0.5, imul(it.kdi_1, $tileHeight) + $tileHeight * 0.5);
      var tmp_0 = Vector2F.q2i(get(Default_getInstance(), -40.0, 40.0), get(Default_getInstance(), -30.0, 10.0));
      var tmp_1 = Vector2F.r2i(0, 98.0);
      var tmp_2 = Companion_getInstance_1().d25_1;
      var tmp_3 = Companion_getInstance_1().d25_1;
      // Inline function 'korlibs.korge.view.text' call
      var this_0 = $particleLayer;
      var text = it.ldi_1.toString();
      var textSize = Companion_instance.eca_1;
      var color = Colors_getInstance().e41_1;
      var font = get_DefaultTtfFontAsBitmap();
      var alignment = Companion_getInstance_7().q4z_1;
      var renderer = get_DefaultStringTextRenderer();
      var autoScaling = Companion_instance.fca_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Text.gca(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.text.<anonymous>' call
      var tmp_4 = addTo(this_1, this_0);
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp$ret$4 = toDuration(2, DurationUnit_SECONDS_getInstance());
      $particles.idl(new Particle(position, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$4));
      // Inline function 'kotlin.Long.div' call
      var tmp$ret$5 = it.ldi_1.a4(toLong(50));
      var progression = numberRangeToLong(1, tmp$ret$5);
      var inductionVariable = progression.kp_1;
      var last = progression.lp_1;
      var tmp_5;
      if (inductionVariable.z1(last) <= 0) {
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable.y3(new Long(1, 0));
          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call
          var tmp_6 = Vector2F.q2i(get(Default_getInstance(), -40.0, 40.0), get(Default_getInstance(), -30.0, 10.0));
          var tmp_7 = Vector2F.r2i(0, 98.0);
          var tmp_8 = Companion_getInstance_1().d25_1;
          var tmp_9 = Companion_getInstance_1().d25_1;
          // Inline function 'korlibs.korge.view.solidRect' call
          var this_2 = $particleLayer;
          var size = Size2D.t26(1, 1);
          var color_0 = Colors_getInstance().e41_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_3 = SolidRect.pd5(size, color_0);
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
          var tmp_10 = addTo(this_3, this_2);
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          var tmp$ret$10 = toDuration(2, DurationUnit_SECONDS_getInstance());
          $particles.idl(new Particle(position, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp$ret$10));
        }
         while (!element.equals(last));
        tmp_5 = Unit_instance;
      }
      tmp = tmp_5;
    } else {
      println('unhandled ' + toString(it));
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda_3($gameState) {
  return function () {
    return $gameState._v.equals(GameState_PLAY_getInstance());
  };
}
function GameScene$sceneMain$lambda_4($field, $gameState, this$0, $fieldView, $stagingView, $particles, $scoreView, $distanceView, $started, $startTimer, $startDuration, $startTimerView, $startTimerText, $gameFinalizedView, $topLayer) {
  return function ($this$addUpdater, dt) {
    var event = $field.mdj(dt.kj_1);
    var tmp;
    if (event instanceof GameOver) {
      $gameState._v = GameState_GAME_OVER_getInstance();
      tmp = Unit_instance;
    } else {
      if (event instanceof NextLevel) {
        $gameState._v = this$0.wdk_1.kdk_1.g1() ? GameState_GAME_WON_getInstance() : GameState_NEXT_LEVEL_getInstance();
        tmp = Unit_instance;
      } else {
        if (event == null) {
          tmp = Unit_instance;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    $fieldView.nda(dt.kj_1);
    $stagingView.oda(get_fast(dt.kj_1));
    $particles.nda(dt.kj_1);
    $scoreView.hap('SCORE: ' + $field.vdi_1.toString());
    $distanceView.hap('DISTANCE: ' + $field.adj_1);
    var tmp_0;
    if ($field.adj_1 <= 0) {
      $distanceView.saz(Colors_getInstance().h41_1);
      tmp_0 = Unit_instance;
    }
    var tmp_1;
    var tmp_2;
    if (!$started._v) {
      var tmp_3 = $startTimer._v;
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(0, DurationUnit_SECONDS_getInstance());
      tmp_2 = tmp_3.equals(new Duration(tmp$ret$0));
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      $started._v = true;
      $field.gdj();
      tmp_1 = Unit_instance;
    } else {
      var tmp_4 = Duration__minus_impl_q5cfm7($startTimer._v.kj_1, dt.kj_1);
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
      $startTimer._v = coerceAtLeast(new Duration(tmp_4), new Duration(tmp$ret$1));
      var timerLeft = Duration__div_impl_dknbf4($startTimer._v.kj_1, $startDuration);
      $startTimerView.hd3(200 * timerLeft);
      var tmp_5;
      var tmp_6 = $startTimer._v;
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(0, DurationUnit_SECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(tmp_6.kj_1, tmp$ret$2) > 0) {
        tmp_5 = _Duration___get_inWholeSeconds__impl__hpy7b3($startTimer._v.kj_1).toString() + ' s';
      } else {
        tmp_5 = '';
      }
      setText($startTimerText, tmp_5);
      tmp_1 = Unit_instance;
    }
    var tmp_7;
    if ($gameFinalizedView._v == null) {
      var tmp_8;
      switch ($gameState._v.r3_1) {
        case 1:
          // Inline function 'korlibs.korge.view.text' call

          var this_0 = $topLayer;
          var text = 'GAME OVER';
          var color = Colors_getInstance().f41_1;
          var font = get_DefaultTtfFontAsBitmap();
          var alignment = Companion_getInstance_7().q4z_1;
          var renderer = get_DefaultStringTextRenderer();
          var autoScaling = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_1 = Text.gca(text, numberToDouble(68), color, font, alignment, renderer, autoScaling, null, null);
          // Inline function 'kotlin.apply' call

          var this_2 = addTo(this_1, this_0);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_2);
          $gameFinalizedView._v = this_2;
          // Inline function 'korlibs.korge.view.text' call

          var this_3 = $topLayer;
          var text_0 = 'GAME OVER';
          var color_0 = Colors_getInstance().e41_1;
          var font_0 = get_DefaultTtfFontAsBitmap();
          var alignment_0 = Companion_getInstance_7().q4z_1;
          var renderer_0 = get_DefaultStringTextRenderer();
          var autoScaling_0 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_4 = Text.gca(text_0, numberToDouble(66), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
          // Inline function 'kotlin.apply' call

          var this_5 = addTo(this_4, this_3);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_5);
          $gameFinalizedView._v = this_5;
          // Inline function 'korlibs.korge.view.text' call

          var this_6 = $topLayer;
          var text_1 = 'GAME OVER';
          var color_1 = Colors_getInstance().g41_1;
          var font_1 = get_DefaultTtfFontAsBitmap();
          var alignment_1 = Companion_getInstance_7().q4z_1;
          var renderer_1 = get_DefaultStringTextRenderer();
          var autoScaling_1 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_7 = Text.gca(text_1, numberToDouble(64), color_1, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
          // Inline function 'kotlin.apply' call

          var this_8 = addTo(this_7, this_6);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_8);
          $gameFinalizedView._v = this_8;
          tmp_8 = Unit_instance;
          break;
        case 3:
          // Inline function 'korlibs.korge.view.text' call

          var this_9 = $topLayer;
          var text_2 = 'YOU ARE THE WINNER';
          var color_2 = Colors_getInstance().f41_1;
          var font_2 = get_DefaultTtfFontAsBitmap();
          var alignment_2 = Companion_getInstance_7().q4z_1;
          var renderer_2 = get_DefaultStringTextRenderer();
          var autoScaling_2 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_10 = Text.gca(text_2, numberToDouble(68), color_2, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
          // Inline function 'kotlin.apply' call

          var this_11 = addTo(this_10, this_9);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_11);
          $gameFinalizedView._v = this_11;
          // Inline function 'korlibs.korge.view.text' call

          var this_12 = $topLayer;
          var text_3 = 'YOU ARE THE WINNER';
          var color_3 = Colors_getInstance().e41_1;
          var font_3 = get_DefaultTtfFontAsBitmap();
          var alignment_3 = Companion_getInstance_7().q4z_1;
          var renderer_3 = get_DefaultStringTextRenderer();
          var autoScaling_3 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_13 = Text.gca(text_3, numberToDouble(66), color_3, font_3, alignment_3, renderer_3, autoScaling_3, null, null);
          // Inline function 'kotlin.apply' call

          var this_14 = addTo(this_13, this_12);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_14);
          $gameFinalizedView._v = this_14;
          // Inline function 'korlibs.korge.view.text' call

          var this_15 = $topLayer;
          var text_4 = 'YOU ARE THE WINNER';
          var color_4 = Colors_getInstance().g41_1;
          var font_4 = get_DefaultTtfFontAsBitmap();
          var alignment_4 = Companion_getInstance_7().q4z_1;
          var renderer_4 = get_DefaultStringTextRenderer();
          var autoScaling_4 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_16 = Text.gca(text_4, numberToDouble(64), color_4, font_4, alignment_4, renderer_4, autoScaling_4, null, null);
          // Inline function 'kotlin.apply' call

          var this_17 = addTo(this_16, this_15);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_17);
          $gameFinalizedView._v = this_17;
          tmp_8 = Unit_instance;
          break;
        case 2:
          // Inline function 'korlibs.korge.view.text' call

          var this_18 = $topLayer;
          var text_5 = 'YOU MADE IT';
          var color_5 = Colors_getInstance().f41_1;
          var font_5 = get_DefaultTtfFontAsBitmap();
          var alignment_5 = Companion_getInstance_7().q4z_1;
          var renderer_5 = get_DefaultStringTextRenderer();
          var autoScaling_5 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_19 = Text.gca(text_5, numberToDouble(68), color_5, font_5, alignment_5, renderer_5, autoScaling_5, null, null);
          // Inline function 'kotlin.apply' call

          var this_20 = addTo(this_19, this_18);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_20);
          $gameFinalizedView._v = this_20;
          // Inline function 'korlibs.korge.view.text' call

          var this_21 = $topLayer;
          var text_6 = 'YOU MADE IT';
          var color_6 = Colors_getInstance().e41_1;
          var font_6 = get_DefaultTtfFontAsBitmap();
          var alignment_6 = Companion_getInstance_7().q4z_1;
          var renderer_6 = get_DefaultStringTextRenderer();
          var autoScaling_6 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_22 = Text.gca(text_6, numberToDouble(66), color_6, font_6, alignment_6, renderer_6, autoScaling_6, null, null);
          // Inline function 'kotlin.apply' call

          var this_23 = addTo(this_22, this_21);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_23);
          $gameFinalizedView._v = this_23;
          // Inline function 'korlibs.korge.view.text' call

          var this_24 = $topLayer;
          var text_7 = 'YOU MADE IT';
          var color_7 = Colors_getInstance().h41_1;
          var font_7 = get_DefaultTtfFontAsBitmap();
          var alignment_7 = Companion_getInstance_7().q4z_1;
          var renderer_7 = get_DefaultStringTextRenderer();
          var autoScaling_7 = Companion_instance.fca_1;
          // Inline function 'korlibs.korge.view.addTo' call

          var this_25 = Text.gca(text_7, numberToDouble(64), color_7, font_7, alignment_7, renderer_7, autoScaling_7, null, null);
          // Inline function 'kotlin.apply' call

          var this_26 = addTo(this_25, this_24);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>' call

          centerOnStage(this_26);
          $gameFinalizedView._v = this_26;
          tmp_8 = Unit_instance;
          break;
        default:
          tmp_8 = Unit_instance;
          break;
      }
      tmp_7 = tmp_8;
    }
    return Unit_instance;
  };
}
function GameScene$sceneMain$slambda_0($gameState, $fieldView, this$0, $field) {
  var i = new GameScene$sceneMain$slambda($gameState, $fieldView, this$0, $field);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda$slambda_0($handler, $it) {
  var i = new GameScene$sceneMain$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function GameScene$sceneMain$lambda_5($this, $handler) {
  return function (it) {
    var tmp = $this.ta0();
    launchImmediately(tmp, GameScene$sceneMain$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function GameState_PLAY_getInstance() {
  GameState_initEntries();
  return GameState_PLAY_instance;
}
function GameState_GAME_OVER_getInstance() {
  GameState_initEntries();
  return GameState_GAME_OVER_instance;
}
function GameState_NEXT_LEVEL_getInstance() {
  GameState_initEntries();
  return GameState_NEXT_LEVEL_instance;
}
function GameState_GAME_WON_getInstance() {
  GameState_initEntries();
  return GameState_GAME_WON_instance;
}
function click$factory() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.z9y_1;
  }, null);
}
function get_levels() {
  _init_properties_main_kt__ykjpl3();
  return levels;
}
var levels;
function main($completion) {
  var tmp = Size2D.t26(512, 512);
  var tmp_0 = Colors_getInstance().r4h('#2b2b2b');
  return Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.qdl_1.qa4();
  var injects = [new GameSceneState(new Long(0, 0), first(get_levels()), drop(get_levels(), 1))];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.l9u_1;
  var tmp = this_0.nag(getKClass(GameScene), injects.slice(), time, transition, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.rdl_1($this.sdl_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = $this.tdl_1($this.udl_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.vdl_1($this.wdl_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.xdl_1($this.ydl_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, it, $completion) {
  var remainingLevels = toMutableList(get_levels());
  $l$loop_0: while (true) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!!remainingLevels.g1()) {
      break $l$loop_0;
    }
    var level = removeFirst(remainingLevels);
    if (level.ddl() === $this.zdl_1.b5u()) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
      var this_0 = $this.adm_1.qa4();
      var injects = [new GameSceneState(new Long(0, 0), level, remainingLevels)];
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
      var transition = this_0.l9u_1;
      var tmp = this_0.nag(getKClass(GameScene), injects.slice(), time, transition, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      break $l$loop_0;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = $this.bdm_1($this.cdm_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function MainMenuScene$sceneMain$slambda_4(this$0) {
  var i = new MainMenuScene$sceneMain$slambda(this$0);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda$slambda_4($handler, $it) {
  var i = new MainMenuScene$sceneMain$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function MainMenuScene$sceneMain$lambda($this, $handler) {
  return function (it) {
    var tmp = $this.ta0();
    launchImmediately(tmp, MainMenuScene$sceneMain$lambda$slambda_4($handler, it));
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$slambda_5($codeBox) {
  var i = new MainMenuScene$sceneMain$slambda_0($codeBox);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda$slambda_5($handler, $it) {
  var i = new MainMenuScene$sceneMain$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function MainMenuScene$sceneMain$lambda_0($this, $handler) {
  return function (it) {
    var tmp = $this.ta0();
    launchImmediately(tmp, MainMenuScene$sceneMain$lambda$slambda_5($handler, it));
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$slambda_6($$this$mouse) {
  var i = new MainMenuScene$sceneMain$slambda_1($$this$mouse);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda$slambda_6($handler, $it) {
  var i = new MainMenuScene$sceneMain$lambda$slambda_1($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function MainMenuScene$sceneMain$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.ta0();
    launchImmediately(tmp, MainMenuScene$sceneMain$lambda$slambda_6($handler, it));
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$slambda_7($really) {
  var i = new MainMenuScene$sceneMain$slambda_2($really);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda$slambda_7($handler, $it) {
  var i = new MainMenuScene$sceneMain$lambda$slambda_2($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function MainMenuScene$sceneMain$lambda_2($this, $handler) {
  return function (it) {
    var tmp = $this.ta0();
    launchImmediately(tmp, MainMenuScene$sceneMain$lambda$slambda_7($handler, it));
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$slambda_8($input, this$0) {
  var i = new MainMenuScene$sceneMain$slambda_3($input, this$0);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda$slambda_8($handler, $it) {
  var i = new MainMenuScene$sceneMain$lambda$slambda_3($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function MainMenuScene$sceneMain$lambda_3($coroutineContext, $mouse, $handler) {
  return function (it) {
    var tmp0_elvis_lhs = $coroutineContext;
    var tmp = tmp0_elvis_lhs == null ? $mouse.ta0() : tmp0_elvis_lhs;
    launchImmediately(tmp, MainMenuScene$sceneMain$lambda$slambda_8($handler, it));
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = readAtlas(get_resourcesVfs().bi('texture5.json'), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var atlas = tmp;
  return new Assets(atlas);
}
function *_generator_get__cbf6n6($this, $completion) {
  var tmp0_elvis_lhs = $this.adl_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.suspend' call
    var tmp_0 = AssetsLoader$get$slambda_0()($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function AssetsLoader$get$slambda_0() {
  var i = new AssetsLoader$get$slambda();
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function Level$code$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.collections.fold' call
    // Inline function 'kotlin.text.map' call
    var this_0 = getStringHashCode(this$0.bdj_1).toString();
    // Inline function 'kotlin.text.mapTo' call
    var destination = ArrayList.w(charSequenceLength(this_0));
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(this_0)) {
      var item = charSequenceGet(this_0, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'Level.code$delegate.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.code' call
      var tmp$ret$1 = Char__toInt_impl_vasixd(item);
      destination.h(tmp$ret$1);
    }
    var accumulator = new Long(0, 0);
    var tmp0_iterator = destination.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'Level.code$delegate.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.Long.plus' call
      // Inline function 'kotlin.Long.times' call
      accumulator = accumulator.z3(toLong(31)).y3(toLong(element));
    }
    var tmp$ret$7 = accumulator;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = toString_0(tmp$ret$7, 36).toUpperCase();
    return padStart(take(tmp$ret$9, 5), 5, _Char___init__impl__6a9atx(65));
  };
}
function *_generator_invoke__zhh2q8_9($this, $this$Korge, $completion) {
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_6()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_2().p2g_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp = views($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var views_0 = tmp;
  var width = size.jl();
  var height = size.kl();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_0 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
    var tmp1_elvis_lhs = base == null ? null : base.z2i();
    rwidth = tmp1_elvis_lhs == null ? views_0.p9o_1.z2i() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.a2j();
    rheight = tmp3_elvis_lhs == null ? views_0.p9o_1.a2j() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.q9u(views_0, defaultTransition, name, Size2D.l2e(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var sceneContainer = addTo(this_0, $this$Korge);
  // Inline function 'korlibs.inject.Injector.mapPrototype' call
  var this_1 = $this$Korge.pa4();
  var gen = main$slambda$lambda_0;
  this_1.e67(getKClass(GameScene), gen);
  // Inline function 'korlibs.inject.Injector.mapPrototype' call
  var this_2 = $this$Korge.pa4();
  var gen_0 = main$slambda$lambda_1;
  this_2.e67(getKClass(MainMenuScene), gen_0);
  // Inline function 'korlibs.inject.Injector.mapSingleton' call
  var this_3 = $this$Korge.pa4();
  var gen_1 = main$slambda$lambda_2;
  this_3.d67(getKClass(AssetsLoader), gen_1);
  get_RegisteredImageFormats().t5o([PNG_getInstance()]);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
  var transition = sceneContainer.l9u_1;
  var tmp_1 = sceneContainer.nag(getKClass(MainMenuScene), injects.slice(), time, transition, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($this$mapPrototype) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = $this$mapPrototype.j67(getKClass(AssetsLoader));
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp$ret$1 = $this$mapPrototype.j67(getKClass(GameSceneState));
  return new GameScene(tmp, tmp$ret$1);
}
function main$slambda$lambda_1($this$mapPrototype) {
  return new MainMenuScene();
}
function main$slambda$lambda_2($this$mapSingleton) {
  return new AssetsLoader();
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.y9j($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function click$factory_0() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.z9y_1;
  }, null);
}
function click$factory_1() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.z9y_1;
  }, null);
}
function click$factory_2() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.z9y_1;
  }, null);
}
function click$factory_3() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.z9y_1;
  }, null);
}
function click$factory_4() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.z9y_1;
  }, null);
}
function code$factory() {
  return getPropertyCallableRef('code', 1, KProperty1, function (receiver) {
    return receiver.ddl();
  }, null);
}
var properties_initialized_main_kt_ask6ij;
function _init_properties_main_kt__ykjpl3() {
  if (!properties_initialized_main_kt_ask6ij) {
    properties_initialized_main_kt_ask6ij = true;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(17, DurationUnit_SECONDS_getInstance());
    var tmp = new Level('1 First Steps', 14, tmp$ret$0);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(15, DurationUnit_SECONDS_getInstance());
    var tmp_0 = new Level('2 Faster and Longer', 15, tmp$ret$1);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$2 = toDuration(13, DurationUnit_SECONDS_getInstance());
    var tmp_1 = new Level('3 Fasterer and Longerer', 16, tmp$ret$2);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$3 = toDuration(17, DurationUnit_SECONDS_getInstance());
    var tmp_2 = new Level('4 Broken Tiles', 14, tmp$ret$3, 2);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$4 = toDuration(15, DurationUnit_SECONDS_getInstance());
    var tmp_3 = new Level('5 More Broken Tiles', 15, tmp$ret$4, 4);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$5 = toDuration(13, DurationUnit_SECONDS_getInstance());
    levels = listOf_0([tmp, tmp_0, tmp_1, tmp_2, tmp_3, new Level('6 Mazing Run', 16, tmp$ret$5, 8)]);
  }
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
function validDirections($this) {
  return listOf_0([$this.rdm_1, $this.rdm_1.cdi()]);
}
function crossPipe($this, tile, tileRect) {
  // Inline function 'korlibs.korge.view.sprite' call
  var this_0 = $this.zdj_1;
  var texture = $this.ydj_1.pdh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.PlayFieldView.crossPipe.<anonymous>' call
  position(this_2, tileRect.v2e(), tileRect.w2e());
  get_centered(this_2);
  size(this_2, $this.gdk_1);
  $this.fdk_1.h(this_2);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = tile.adn_1.s1().a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'view.PlayFieldView.crossPipe.<anonymous>' call
    var innerTile = element.u1();
    // Inline function 'korlibs.korge.view.sprite' call
    var this_3 = $this.zdj_1;
    var initialAnimation = $this.ydj_1.vdh_1;
    var anchor_0 = Companion_getInstance_4().n24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Sprite.vd8(initialAnimation, anchor_0);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'view.PlayFieldView.crossPipe.<anonymous>.<anonymous>' call
    position(this_5, tileRect.v2e(), tileRect.w2e());
    get_centered(this_5);
    size(this_5, $this.gdk_1);
    var tmp0_safe_receiver = innerTile.ydm_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ddi();
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Angle(tmp_0)) == null) {
      tmp = Companion_getInstance_1().d25_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    rotation(this_5, tmp);
    updateLiquidFrame(this_5, $this, !(innerTile.ydm_1 == null), innerTile.xdm_1, innerTile.vdm_1);
    var liquidView = this_5;
    $this.fdk_1.h(liquidView);
  }
}
function straightPipe($this, tile, tileRect) {
  // Inline function 'korlibs.korge.view.sprite' call
  var this_0 = $this.zdj_1;
  var texture = $this.ydj_1.rdh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.PlayFieldView.straightPipe.<anonymous>' call
  position(this_2, tileRect.v2e(), tileRect.w2e());
  get_centered(this_2);
  size(this_2, $this.gdk_1);
  rotation(this_2, first(tile.cdn_1.gdi_1).ddi());
  $this.fdk_1.h(this_2);
  // Inline function 'korlibs.korge.view.sprite' call
  var this_3 = $this.zdj_1;
  var initialAnimation = $this.ydj_1.vdh_1;
  var anchor_0 = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Sprite.vd8(initialAnimation, anchor_0);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, this_3);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.PlayFieldView.straightPipe.<anonymous>' call
  position(this_5, tileRect.v2e(), tileRect.w2e());
  get_centered(this_5);
  size(this_5, $this.gdk_1);
  var tmp0_safe_receiver = tile.edn_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ddi();
  var tmp;
  var tmp_0 = tmp1_elvis_lhs;
  if ((tmp_0 == null ? null : new Angle(tmp_0)) == null) {
    tmp = Companion_getInstance_1().d25_1;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  rotation(this_5, tmp);
  updateLiquidFrame(this_5, $this, !(tile.edn_1 == null), tile.ddn_1, tile.bdn_1);
  var liquidView = this_5;
  $this.fdk_1.h(liquidView);
}
function startPipe($this, tile, tileRect) {
  // Inline function 'korlibs.korge.view.sprite' call
  var this_0 = $this.zdj_1;
  var texture = $this.ydj_1.odh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.PlayFieldView.startPipe.<anonymous>' call
  position(this_2, tileRect.v2e(), tileRect.w2e());
  get_centered(this_2);
  size(this_2, tileRect.e1());
  rotation(this_2, tile.idj_1.ddi());
  $this.fdk_1.h(this_2);
  // Inline function 'korlibs.korge.view.sprite' call
  var this_3 = $this.zdj_1;
  var initialAnimation = $this.ydj_1.sdh_1;
  var anchor_0 = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Sprite.vd8(initialAnimation, anchor_0);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, this_3);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.PlayFieldView.startPipe.<anonymous>' call
  position(this_5, tileRect.v2e(), tileRect.w2e());
  get_centered(this_5);
  size(this_5, tileRect.e1());
  rotation(this_5, tile.idj_1.ddi());
  updateLiquidFrame(this_5, $this, !(tile.kdj_1 == null), tile.jdj_1, tile.hdj_1);
  var liquidView = this_5;
  $this.fdk_1.h(liquidView);
}
function updateLiquidFrame(_this__u8e3s4, $this, liquid, elapsed, length) {
  if (liquid) {
    var elapsedRatio = coerceAtMost(Duration__div_impl_dknbf4(elapsed, length), 0.9999);
    var frame = numberToInt((_this__u8e3s4.qd8() - 1 | 0) * elapsedRatio);
    _this__u8e3s4.xd8(1 + frame | 0);
  } else {
    _this__u8e3s4.xd8(0);
  }
}
function cornerPipe($this, tile, tileRect) {
  // Inline function 'korlibs.korge.view.sprite' call
  var this_0 = $this.zdj_1;
  var texture = $this.ydj_1.ndh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.PlayFieldView.cornerPipe.<anonymous>' call
  position(this_2, tileRect.v2e(), tileRect.w2e());
  get_centered(this_2);
  size(this_2, $this.gdk_1);
  rotation(this_2, tile.rdm_1.ddi());
  $this.fdk_1.h(this_2);
  var tmp;
  if (tile.rdm_1.equals(tile.tdm_1)) {
    // Inline function 'korlibs.korge.view.sprite' call
    var this_3 = $this.zdj_1;
    var initialAnimation = $this.ydj_1.udh_1;
    var anchor_0 = Companion_getInstance_4().n24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Sprite.vd8(initialAnimation, anchor_0);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'view.PlayFieldView.cornerPipe.<anonymous>' call
    position(this_5, tileRect.v2e(), tileRect.w2e());
    get_centered(this_5);
    size(this_5, $this.gdk_1);
    rotation(this_5, tile.rdm_1.ddi());
    updateLiquidFrame(this_5, $this, !(tile.tdm_1 == null), tile.sdm_1, tile.qdm_1);
    tmp = this_5;
  } else {
    // Inline function 'korlibs.korge.view.sprite' call
    var this_6 = $this.zdj_1;
    var initialAnimation_0 = $this.ydj_1.tdh_1;
    var anchor_1 = Companion_getInstance_4().n24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_7 = Sprite.vd8(initialAnimation_0, anchor_1);
    // Inline function 'kotlin.apply' call
    var this_8 = addTo(this_7, this_6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'view.PlayFieldView.cornerPipe.<anonymous>' call
    position(this_8, tileRect.v2e(), tileRect.w2e());
    get_centered(this_8);
    size(this_8, $this.gdk_1);
    rotation(this_8, tile.rdm_1.ddi());
    updateLiquidFrame(this_8, $this, !(tile.tdm_1 == null), tile.sdm_1, tile.qdm_1);
    tmp = this_8;
  }
  var liquidView = tmp;
  $this.fdk_1.h(liquidView);
}
function blockedTile($this, tileRect) {
  // Inline function 'korlibs.korge.view.sprite' call
  var this_0 = $this.zdj_1;
  var texture = $this.ydj_1.kdh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.PlayFieldView.blockedTile.<anonymous>' call
  position(this_2, tileRect.v2e(), tileRect.w2e());
  get_centered(this_2);
  size(this_2, $this.gdk_1);
  $this.fdk_1.h(this_2);
}
function baseCornerPipe(_this__u8e3s4, assets, tileRect, tile) {
  // Inline function 'korlibs.korge.view.sprite' call
  var texture = assets.ndh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.baseCornerPipe.<anonymous>' call
  position(this_1, tileRect.v2e(), tileRect.w2e());
  get_centered(this_1);
  size(this_1, tileRect.e1());
  rotation(this_1, tile.rdm_1.ddi());
  return this_1;
}
function baseStraigthPipe(_this__u8e3s4, assets, tileRect, tile) {
  // Inline function 'korlibs.korge.view.sprite' call
  var texture = assets.rdh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.baseStraigthPipe.<anonymous>' call
  position(this_1, tileRect.v2e(), tileRect.w2e());
  get_centered(this_1);
  size(this_1, tileRect.e1());
  rotation(this_1, first(tile.cdn_1.gdi_1).ddi());
  return this_1;
}
function baseCrossPipe(_this__u8e3s4, assets, tileRect, tile) {
  // Inline function 'korlibs.korge.view.sprite' call
  var texture = assets.pdh_1;
  var anchor = Companion_getInstance_4().n24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Sprite.ud8(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'view.baseCrossPipe.<anonymous>' call
  position(this_1, tileRect.v2e(), tileRect.w2e());
  get_centered(this_1);
  size(this_1, tileRect.e1());
  return this_1;
}
//region block: post-declaration
initMetadataForClass(Assets, 'Assets');
initMetadataForClass(Direction, 'Direction');
initMetadataForCompanion(Companion);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForClass(GameOver, 'GameOver');
initMetadataForClass(NextLevel, 'NextLevel');
initMetadataForClass(Scored, 'Scored');
initMetadataForClass(Placed, 'Placed');
initMetadataForClass(StagingArea, 'StagingArea', StagingArea);
initMetadataForClass(PlayField, 'PlayField');
initMetadataForClass(GameSceneState, 'GameSceneState');
initMetadataForClass(GameState, 'GameState');
initMetadataForLambda(GameScene$sceneMain$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$lambda$slambda, VOID, VOID, [0]);
initMetadataForClass(GameScene, 'GameScene', VOID, VOID, VOID, [0]);
initMetadataForLambda(MainMenuScene$sceneMain$slambda, VOID, VOID, [1]);
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(MainMenuScene$sceneMain$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(MainMenuScene$sceneMain$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(MainMenuScene$sceneMain$slambda_2, VOID, VOID, [1]);
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(MainMenuScene$sceneMain$slambda_3, VOID, VOID, [1]);
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda_3, VOID, VOID, [0]);
initMetadataForClass(MainMenuScene, 'MainMenuScene', MainMenuScene, VOID, VOID, [0]);
initMetadataForLambda(AssetsLoader$get$slambda, VOID, VOID, [0]);
initMetadataForClass(AssetsLoader, 'AssetsLoader', AssetsLoader, VOID, VOID, [0]);
initMetadataForClass(Level, 'Level');
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForClass(Tile, 'Tile');
initMetadataForClass(BlockedTile, 'BlockedTile', BlockedTile);
initMetadataForClass(CornerPipe, 'CornerPipe');
initMetadataForClass(Inner, 'Inner');
initMetadataForClass(CrossPipe, 'CrossPipe');
initMetadataForClass(EmptyTile, 'EmptyTile', EmptyTile);
initMetadataForClass(StartPipe, 'StartPipe');
initMetadataForClass(StraightPipe, 'StraightPipe');
initMetadataForClass(Overflow, 'Overflow');
initMetadataForClass(Particle, 'Particle');
initMetadataForClass(Particles, 'Particles');
initMetadataForClass(PlayFieldView, 'PlayFieldView');
initMetadataForClass(StagingAreaView, 'StagingAreaView');
//endregion
//region block: init
Companion_instance_1 = new Companion();
//endregion
mainWrapper();
